import Validation from "./validationMethods";
import Alert from "./alert";

//added is the input number validation
export function isValidNum(inputtxt) {
  var numbers = /^[0-9]+$/;
  if (inputtxt.match(numbers)) {
    return true;
  }
  return false;
}

export function isValidEmail(mail) {
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail);
}

export function isValidPassword(password) {
  return password.length >= 8;
}

export function isNumericOrFloat(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export function isNumeric(inputtxt) {
  var numbers = /^[0-9]+$/;
  if (inputtxt.match(numbers)) {
    return true;
  }
  return false;
}

/**
 * @method validateCreateRoomFields : Method for login page validations.
 * @param {Object} data : Data to be validated.
 */
export const validateCreateRoomFields = (data) => {
  if (data.name === "") {
    Alert(400, "Please enter game name");
    return false;
  } else if (data.round <= 0) {
    Alert(400, "Please enter correct no of rounds to start the game");
    return false;
  } else if (data.round > 13) {
    Alert(400, "Max rounds can be 13 only");
    return false;
  }
  // else if (data.ratings=== 0){
  //     Alert(400, "Please select ratig");
  //     return false;
  // }

  return true;
};
